export default __webpack_public_path__ + "static/media/d7.a6618d0c.jpeg";